import { getDatasetSafe } from '@nx-paeonia/utils-dom';
import { captureException } from '@sentry/browser';

export function initUpsellBlock() {
  const upsellBlock = document.querySelector<HTMLElement>('[data-upsell-url]');
  if (!upsellBlock) return;
  const upsellUrl = getDatasetSafe<string>(upsellBlock, 'upsellUrl');

  if (!upsellUrl) return;
  fetch(upsellUrl)
    .then((response) => response.text())
    .then((html) => {
      upsellBlock.innerHTML = html;

      if (upsellBlock.children.length > 0) upsellBlock.closest('y-configurator-slide')?.removeAttribute('hidden');
    })
    .catch((error: Error) => {
      captureException(error);
    });
}
